import { app } from '../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.manage-application.configuration', {
        url: '/configuration',
        component: 'companyManageApplicationConfiguration',
    });
}



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/configuration/application-configuration.state.js